import { Canvas, StaticCanvas, config } from 'fabric';
import { backgroundColor } from '@/config/options';

// A namespace-safe branch over the two named canvas classes (they can't be indexed dynamically off the
// `fabric` namespace). Overloads: the interactive default returns a `Canvas`; only the display-only
// branch is a `StaticCanvas` — so the (sole) `initialiseCanvas(el)` caller gets a concrete `Canvas`.
function initialiseCanvas(
  canvasEl: HTMLCanvasElement | string,
  isDisplayOnly?: false,
): Canvas;
function initialiseCanvas(
  canvasEl: HTMLCanvasElement | string,
  isDisplayOnly: true,
): StaticCanvas;
function initialiseCanvas(
  canvasEl: HTMLCanvasElement | string,
  isDisplayOnly = false,
): Canvas | StaticCanvas {
  config.devicePixelRatio = 2;
  const options = {
    isDrawingMode: false,
    selection: true,
    hoverCursor: '-webkit-grab',
    moveCursor: '-webkit-grabbing',
    preserveObjectStacking: true, // false == last touched item takes stack priority
    uniformScaling: false,
    backgroundColor,
  };
  return isDisplayOnly
    ? new StaticCanvas(canvasEl, options)
    : new Canvas(canvasEl, options);
}

export default initialiseCanvas;
